import React, { useState, useEffect, useContext } from 'react';
import { Container, Row, Col, Card, Badge, Button, ButtonGroup, Pagination } from 'react-bootstrap';
import {
  FaBell, FaCheckCircle, FaCreditCard, FaCalendarAlt,
  FaEnvelope, FaMapMarkerAlt, FaTrashAlt, FaCheckDouble
} from 'react-icons/fa';
import Swal from 'sweetalert2';
import '../../../../assets/css/customer/dashboard/CustomerNotifications.css';
import CustomerLayout from '../../../../layouts/customer/CustomerLayout';
import AppContext from '../../../../context/AppContext';
import axios from 'axios';

const CustomerNotifications = () => {

  
  const [notifications,        setNotifications]        = useState([]);
  const [activeFilter,         setActiveFilter]         = useState('all');
  const [currentPage,          setCurrentPage]          = useState(1);
  const [notificationsPerPage] = useState(5);
  const [loading,              setLoading]              = useState(false);

  const { baseUrl } = useContext(AppContext);

  
  const viewAllNotifications = (loggedInCustomer) => {
    const formData = new FormData();
    formData.append('wecustomer_id', loggedInCustomer.id);

    axios.post(`${baseUrl}/customer/notifications/viewAllNotifications`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    })
    .then((res) => {
      if (res.data.success === true) {
        setNotifications(res.data.notifications);
      }
    })
    .catch((err) => console.log(err));
  };

  useEffect(() => {
  const loggedInCustomer = JSON.parse(localStorage.getItem('loggedInCustomer'));
  
  if (loggedInCustomer != null) {
    viewAllNotifications(loggedInCustomer);
  }
}, []);

  useEffect(() => {
    setCurrentPage(1);
  }, [activeFilter]);

  const markAsRead = (id) => {
    const formData = new FormData();
    formData.append('id',     id);
    formData.append('status', 'read');

    axios.post(`${baseUrl}/customer/notifications/updateNotification`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    })
    .then((res) => {
      if (res.data.success === true) {
        setNotifications(notifications.map(n => n.id === id ? { ...n, status: 'read' } : n));
      }
    })
    .catch((err) => console.log(err));
  };

  
  const markAllAsRead = () => {
    setLoading(true);
    const unread = notifications.filter(n => n.status === 'unread');
    const loggedInCustomer = JSON.parse(localStorage.getItem('loggedInCustomer'));

    const promises = unread.map(n => {
      const formData = new FormData();
      formData.append('id',     n.id);
      formData.append('status', 'read');
      return axios.post(`${baseUrl}/customer/notifications/updateNotification`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
    });

    Promise.all(promises).then(() => {
      viewAllNotifications(loggedInCustomer);
      setLoading(false);
      Swal.fire({ icon: 'success', title: 'All Marked as Read', timer: 1500, showConfirmButton: false });
    });
  };

  
  const deleteNotification = (id) => {
    axios.delete(`${baseUrl}/customer/notifications/deleteNotification/${id}`)
    .then((res) => {
      if (res.data.success === true) {
        setNotifications(notifications.filter(n => n.id !== id));
        Swal.fire({ icon: 'success', title: 'Deleted', timer: 1200, showConfirmButton: false });
      }
    })
    .catch((err) => console.log(err));
  };

  const clearAllNotifications = async () => {
    const result = await Swal.fire({
      title: 'Clear All Notifications?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#dc3545',
      cancelButtonColor: '#6c757d',
      confirmButtonText: 'Yes, Clear All'
    });

    if (result.isConfirmed) {
      setLoading(true);
      const promises = notifications.map(n =>
        axios.delete(`${baseUrl}/customer/notifications/deleteNotification/${n.id}`)
      );
      Promise.all(promises).then(() => {
        setNotifications([]);
        setLoading(false);
        Swal.fire({ icon: 'success', title: 'Cleared', timer: 1500, showConfirmButton: false });
      });
    }
  };

  // Filter
  const getFilteredNotifications = () => {
    if (activeFilter === 'all')    return notifications;
    if (activeFilter === 'unread') return notifications.filter(n => n.status === 'unread');
    return notifications.filter(n => n.type === activeFilter);
  };

  const getUnreadCount = () => notifications.filter(n => n.status === 'unread').length;

  const filteredNotifications     = getFilteredNotifications();
  const indexOfLast               = currentPage * notificationsPerPage;
  const indexOfFirst              = indexOfLast - notificationsPerPage;
  const currentNotifications      = filteredNotifications.slice(indexOfFirst, indexOfLast);
  const totalPages                = Math.ceil(filteredNotifications.length / notificationsPerPage);

  const filterCategories = [
    { id: 'all',    label: 'All',         icon: <FaBell /> },
    { id: 'unread', label: 'Unread',      icon: <FaCheckCircle /> },
  ];

  return (
    <CustomerLayout>
    <div className="notifications-page">
      <Container fluid>

        {/* Header */}
        <div className="notifications-header">
          <div className="header-content">
            <h2 className="notifications-title">
              <FaBell className="me-2" />
              Notifications
              {getUnreadCount() > 0 && (
                <Badge bg="danger" className="unread-badge ms-2">{getUnreadCount()}</Badge>
              )}
            </h2>
            <p className="notifications-subtitle">Stay updated with your wedding planning</p>
          </div>
        </div>

        {/* Filters + Actions */}
        <Card className="filters-card mb-4">
          <Card.Body>
            <div className="filters-actions-wrapper">
              <ButtonGroup className="filter-buttons-group">
                {filterCategories.map((category) => (
                  <Button
                    key={category.id}
                    variant={activeFilter === category.id ? 'primary' : 'outline-secondary'}
                    className={`filter-btn ${activeFilter === category.id ? 'active' : ''}`}
                    onClick={() => setActiveFilter(category.id)}
                  >
                    {category.icon}
                    <span className="filter-label ms-2">{category.label}</span>
                    {category.id === 'unread' && getUnreadCount() > 0 && (
                      <Badge bg="danger" className="filter-badge ms-2">{getUnreadCount()}</Badge>
                    )}
                  </Button>
                ))}
              </ButtonGroup>

              <div className="action-buttons-group">
                <Button
                  variant="outline-primary"
                  className="btn-mark-all"
                  onClick={markAllAsRead}
                  disabled={getUnreadCount() === 0 || loading}
                >
                  <FaCheckDouble className="me-2" /> Mark all as read
                </Button>
                <Button
                  variant="outline-danger"
                  className="btn-clear-all"
                  onClick={clearAllNotifications}
                  disabled={notifications.length === 0 || loading}
                >
                  <FaTrashAlt className="me-2" /> Clear all
                </Button>
              </div>
            </div>
          </Card.Body>
        </Card>

        {/* List */}
        <Row>
          <Col lg={12}>
            {filteredNotifications.length === 0 ? (
              <Card className="empty-state-card">
                <Card.Body className="text-center py-5">
                  <FaBell className="empty-icon mb-3" />
                  <h5>No Notifications</h5>
                  <p className="text-muted">You're all caught up!</p>
                </Card.Body>
              </Card>
            ) : (
              <>
                <div className="notifications-list">
                  {currentNotifications.map((notification) => (
                    <Card
                      key={notification.id}
                      className={`notification-item ${notification.status === 'unread' ? 'unread' : ''}`}
                      onClick={() => notification.status === 'unread' && markAsRead(notification.id)}
                    >
                      <Card.Body>
                        <div className="notification-content">
                          <div className="notification-main">
                            <div className="notification-details">
                              <div className="notification-header-row">
                                <h5 className="notification-title">{notification.title}</h5>
                                {notification.status === 'unread' && (
                                  <div className="unread-indicator"></div>
                                )}
                              </div>
                              <p className="notification-message">{notification.descrption}</p>
                              <span className="notification-time">{notification.created_at?.slice(0, 10)}</span>
                            </div>
                          </div>
                          <div className="notification-actions">
                            <Button
                              variant="link"
                              size="sm"
                              className="btn-delete-notification"
                              onClick={(e) => { e.stopPropagation(); deleteNotification(notification.id); }}
                            >
                              <FaTrashAlt />
                            </Button>
                          </div>
                        </div>
                      </Card.Body>
                    </Card>
                  ))}
                </div>

                {totalPages > 1 && (
                  <div className="notifications-pagination mt-4">
                    <Pagination className="custom-pagination">
                      <Pagination.Prev
                        onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
                        disabled={currentPage === 1}
                      />
                      {[...Array(totalPages)].map((_, index) => (
                        <Pagination.Item
                          key={index + 1}
                          active={index + 1 === currentPage}
                          onClick={() => setCurrentPage(index + 1)}
                        >
                          {index + 1}
                        </Pagination.Item>
                      ))}
                      <Pagination.Next
                        onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
                        disabled={currentPage === totalPages}
                      />
                    </Pagination>
                  </div>
                )}
              </>
            )}
          </Col>
        </Row>

      </Container>
    </div>
    </CustomerLayout>
  );
};

export default CustomerNotifications;